
import { defineComponent, reactive, watch, PropType } from "vue";
import { FirebaseError } from "firebase/app";

type Type = "alert" | "snackBar";
export default defineComponent({
  name: "ErrorAlert",
  props: {
    error: Error,
    handler: PropType<(Error) => string | null>,
    type: PropType<Type>,
  },
  setup(props) {
    const data = reactive({
      message: null as string | null,
      alert: false,
      snackbar: false,
    });

    const getMessage = () => {
      if (!props.error) {
        data.message = null;
      }

      if (props.handler) {
        data.message = props.handler(props.error);
        if (data.message !== null) {
          return;
        }
      }

      if (props.error instanceof FirebaseError) {
        const messages = {
          "invalid-argument": "無効なリクエストです。",
          unauthenticated: "ログインが必要な操作です。",
          "permission-denied": "必要な権限がありません。",
          unavailable: "現在メンテナンス中です。",
          "not-found": "要求されたデータは存在しません。",
        };

        data.message = messages[props.error?.code.substring(10)];
      }
    };

    const show = () => {
      if (props.error) {
        switch (props.type) {
          case "alert":
            data.alert = true;
            break;

          case "snackBar":
            data.snackbar = true;
            break;

          default:
            data.alert = true;
            break;
        }
      } else {
        data.alert = false;
        data.snackbar = false;
      }
    };

    watch(props, () => {
      getMessage();
      show();
    });

    getMessage();
    show();

    return { data };
  },
});
